<script>
export default {
    name: "ApiLogs",
    data() {
        return {
            tableBusy: false,
            tableData: [],
            modalTitle: "",
            opcr: null
        };
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
    },
    methods: {
        getData(opcr) {
            this.opcr = opcr;
            this.tableBusy = true;
            this.$store
                .dispatch("preopcr/GetOPCRLogs", opcr.id)
                .then((res) => {
                    this.tableBusy = false;
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    // sort by date
                    res.data.sort((a, b) => {
                        return new Date(b.date) - new Date(a.date);
                    });
                    res.data.map((item) => {
                        item.dateWTime = this.formatDateWithTime(
                            new Date(item.date)
                        );
                        item.splitted = item.dateWTime.split(" at ");
                    });
                    this.tableData = res.data;
                    this.tableBusy = false;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        viewStatus(type){
            if(type == 'planning'){
                return this.opcr.planningStatus && this.opcr.planningStatus.toLowerCase() == 'approved';
            }else if(type == 'finance'){
                return this.opcr.financeStatus && this.opcr.financeStatus.toLowerCase() == 'approved';
            }
            return this.opcr.status && this.opcr.status.toLowerCase() == 'approved';
        }
    },
};
</script>

<template>
    <b-modal
        id="opcr-logs-modal"
        :title="modalTitle"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <div class="progress-card" v-if="opcr">
            <div class="d-flex justify-content-center my-5 parent-div">
                <div class="prog-div text-center text-glow-success cursor-pointer">
                    <div class="circle justify-content-center d-flex align-items-center">
                        <i class="mdi mdi-clipboard-edit-outline w-100" ></i>
                    </div>
                    <p class="mb-0 mt-2">Created</p>
                </div>
                <div class="horizontal-small-line success position-relative glow-line">
                    <div></div>
                </div>
                <div class="vertical-big-line">
                    <div class="top success"></div>
                    <div class="bottom success"></div>
                </div>
                <div class="multiple-line">
                    <div class="top-line success" ></div>
                    <div class="bottom-line success"></div>
                </div>
                <div class="multiple-circle">
                    <div class="top">
                        <div 
                            class="position-relative w-100" 
                            :class="{
                                'text-glow-success': viewStatus('planning'), 
                                'quarter-success': !viewStatus('planning'), 
                            }" 
                        >
                            <div class="small-circle justify-content-center d-flex align-items-center">
                                <i class="mdi mdi-shield-account w-100 small" ></i>
                            </div>
                            <p class="position-absolute text-center absolute-centerX">PME Approved</p>
                        </div>
                    </div>
                    <div class="bottom">
                        <div 
                            class="position-relative w-100" 
                            :class="{
                                'text-glow-success': viewStatus('finance'), 
                                'quarter-success': !viewStatus('finance'), 
                            }" 
                            >
                            <div class="small-circle justify-content-center d-flex align-items-center">
                                <i class="mdi mdi-bank w-100 small" ></i>
                            </div>
                            <p class="position-absolute text-center absolute-centerX">Finance Approved</p>
                        </div>
                    </div>
                </div>
                <div class="multiple-line">
                    <div class="top-line" :class="{'success': viewStatus('planning')}"></div>
                    <div class="bottom-line" :class="{'success': viewStatus('finance')}"></div>
                </div>
                <div class="vertical-big-line">
                    <div class="top" :class="{'success': viewStatus('planning')}"></div>
                    <div class="bottom" :class="{'success': viewStatus('finance')}"></div>
                </div>
                <div 
                    class="horizontal-small-line position-relative" 
                    :class="{
                        'success glow-line': viewStatus('planning') && viewStatus('finance')
                    }">
                    <div></div>
                </div>
                <div class="prog-div text-center" 
                    :class="{
                        'text-glow-success': viewStatus('planning') && viewStatus('finance') && viewStatus('status'), 
                        'quarter-success': viewStatus('planning') && viewStatus('finance') && !viewStatus('status'), 
                    }" 
                    >
                    <div class="circle justify-content-center d-flex align-items-center">
                        <i class="mdi mdi-thumb-up w-100" ></i>
                    </div>
                    <p class="mb-0 mt-2">PMT Approved</p>
                </div>
                <div class="horizontal-small-line position-relative" :class="{'success glow-line': viewStatus('status')}">
                    <div></div>
                </div>
                <div class="prog-div text-center" 
                    :class="{
                        'text-glow-success': viewStatus('status') && opcr.imported, 
                        'quarter-success': viewStatus('status') && !opcr.imported, 
                    }" 
                    >
                    <div class="circle justify-content-center d-flex align-items-center">
                        <i class="mdi mdi-upload w-100" ></i>
                    </div>
                    <p class="mb-0 mt-2">Imported</p>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center pt-5">
            <ul class="verti-timeline list-unstyled">
                <li class="event-list" v-for="(x, xIndex) in tableData" :key="x.id" :class="{'active': xIndex == 0}">
                    <div class="event-timeline-dot">
                        <i class="bx bx-right-arrow-circle font-size-18" :class="{'bx-fade-right': xIndex == 0}"></i>
                    </div>
                    <div class="media">
                        <div class="me-3">
                            <h5 class="font-size-14 mb-0">
                                {{x.splitted[0]}}
                                <i
                                    class="
                                        bx bx-right-arrow-alt
                                        font-size-16
                                        text-primary
                                        align-middle
                                        ms-2
                                    "
                                ></i>
                            </h5>
                            <small>{{x.splitted[1]}}</small>
                        </div>
                        <div class="media-body" style="max-width:180px;">
                            <div class="mb-0" style="line-height:14px;">{{x.log}}</div>
                            <div><small>({{x.user.completeName.trim()}})</small></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </b-modal>
</template>